import { sendGTMEvent } from '@next/third-parties/google'
import type { GtmGlobalStoreProps } from '../../useGTM'
import { getEcommerceObjectFromCart } from '../../helpers/getEcommerceObjectFromCart'

export type GtmCheckoutPurchaseButtonClickedType = {
  payment_method: string
}

export const gtmCheckoutPurchaseButtonClicked = ({
  globalStore,
  payment_method,
}: GtmGlobalStoreProps & GtmCheckoutPurchaseButtonClickedType) => {
  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'sho_checkout_purchase_clicked',
    event_id: uuid,
    payment_method,
    cart: getEcommerceObjectFromCart({
      globalStore,
      cart: [...globalStore.cart.otp, ...globalStore.cart.subscribe],
    }),
  })
}
